import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ServerUrl } from "../Utils";
import "../styles/register.css";

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    participantId: "",
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    drivingLicenseId: "",
  });
  const [isTokenVerified, setIsTokenVerified] = useState(false);
  const [tokenEmail, setTokenEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailError, setEmailError] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
     setFormData(prev => ({ ...prev, token }));
      console.log("Token found:", token);
      const verifyToken = async () => {
        try {
          const response = await fetch(`${ServerUrl}/users/verify-reset-token`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          });

          const data = await response.json();
          
          if (data.status === 200) {

            setFormData(prev => ({
              ...prev,
              participantId: data.data.participantId || "",
              firstName: data.data.firstName || "",
              lastName: data.data.lastName || "",
              drivingLicenseId: data.data.drivingLicenseId || ""
            }));
            setTokenEmail(data.data.email || "");
            setIsTokenVerified(true);
          } else {
            console.error("Token verification failed:", data.message);
            alert("Invalid or expired token");
            setIsTokenVerified(false);
          }
        } catch (error) {
          console.error("Error verifying token:", error);
          alert("Error verifying token");
          setIsTokenVerified(false);
        }
      };
      
      
      verifyToken();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isTokenVerified) {
      alert("Please wait for token verification to complete");
      return;
    }
    
    if (formData.email !== tokenEmail) {
      setEmailError(true);
      return;
    } else {
      setEmailError(false);
    }
    
    try {
      const response = await fetch(`${ServerUrl}/users/register/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      
      if (data.status === 200) {
        alert("Registration successful! Please check your email for welcome message.");
        navigate("/login");
      } else {
        alert(data.message || "Registration failed");
      }
    } catch (error) {
      alert("Error during registration");
      console.error("Registration error:", error);
    }
  };

  return (
    <div id="register">
      <h1 className="register-title">Hazard Perception</h1>
      <div className="register-container">
          <h2 className="register-header">User Registration</h2>
          <h2 className="register-header">Welcome {formData.firstName} {formData.lastName}</h2>

        
        <form onSubmit={handleSubmit} className="register-form">
          {/* <div className="form-group">
            <label className="form-label">Participant ID:</label>
            <input
              type="text"
              name="participantId"
              value={formData.participantId}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div> */}

          <div className="form-group">
            <label className="form-label">Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className={`form-input ${emailError ? 'error-input' : ''}`}
            />
            {emailError && (
              <div className="error-message">
                Please use the correct email associated with the registration. Please contact admin if any support needed. 
              </div>
            )}
          </div>
{/* 
          <div className="form-group">
            <label className="form-label">First Name:</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="pannalam"
            />
          </div> */}

          {/* <div className="form-group">
            <label className="form-label">Last Name:</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="vachchi kduu"
            />
          </div> */}

          <div className="form-group">
            <label className="form-label">Password:</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="form-input password-input"
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg className="eye-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                ) : (
                  <svg className="eye-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Confirm Password:</label>
            <div className="password-input-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                className="form-input password-input"
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <svg className="eye-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                ) : (
                  <svg className="eye-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* <div className="form-group">
            <label className="form-label">Driving License ID:</label>
            <input
              type="text"
              name="drivingLicenseId"
              value={formData.drivingLicenseId}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div> */}

          <button
            type="submit"
            className="register-button"
            disabled={!isTokenVerified && !!formData.token}
          >
            Register
          </button>
        </form>
      </div>
    </div>
  );
}

export default Register;
